import { ProjectStatistics } from '../types/projectStatisticsType';
import { Project } from '../types/projectTypes';
import apiClient from './apiClient';

export const getTypeTower = async (idProject: number): Promise<string[]> => {
  const response = await apiClient.get(`/Towers/types/${idProject}`);
  return response.data;
}

export const getCountTypeTower = async (idProject: number, suspensionTower: string[], anchorTower: string[]): Promise<any> => {
  const response = await apiClient.post(`Towers/types/${idProject}/count`, {
    suspensionTower,
    anchorTower
  });
  return response.data;
};

export const getProjects = async (): Promise<Project[]> => {
  const response = await apiClient.get('/Projects');
  return response.data;
};

export const getActiveProjects = async () => {
  const response = await apiClient.get('/Projects/active');
  return response.data;
};

export const deleteProject = async (id: number): Promise<void> => {
  await apiClient.delete(`/Projects/${id}`);
};

export const getProjectById = async (id: number): Promise<Project> => {
  try {
    const response = await apiClient.get(`/Projects/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener el proyecto:', error);
    throw new Error('Error al obtener el proyecto');
  }
};


export const getGraphics = async (idProject: number, startDate: string, finishDate: string): Promise<any> => {
  const response = await apiClient.get(`/ras/${idProject}/grafic`, { params: { startDate, finishDate }});
  return response.data;
}

export const createProject = async (project: Project): Promise<Project> => {
  const response = await apiClient.post('/Projects', project);
  return await response.data;
};

export const updateProject = async (updatedProject: Project): Promise<Project> => {
  const response = await apiClient.put(`/Projects/${updatedProject.id}`, updatedProject)
  return response.data;
};

export const getStatistics = async (projectId: number): Promise<ProjectStatistics> => {
  const response = await apiClient.get(`/Towers/statistics/${projectId}`)
  return response.data;
};
